import { Link } from 'react-router-dom';

function Home() {
  return (
    <>
      <nav className="navbar">
        <div className="logo">CoinTrust.ai</div>
        <div className="nav-links">
          <a href="#">Cryptocurrencies</a>
          <a href="#">Individuals</a>
          <a href="#">Businesses</a>
          <a href="#">Developers</a>
          <a href="#">Company</a>
          <Link to="/login" className="signin-btn">Sign in</Link>
          <Link to="/signup" className="signup-btn">Sign up</Link>
        </div>
      </nav>

      <section className="hero">
        <div className="hero-text">
          <h1>The future of money is here</h1>
          <p>We're the most trusted place for people and businesses to buy, sell, and use crypto.</p>
          <div className="email-signup">
            <input type="email" placeholder="Your email address" />
            <Link to="/signup">
              <button className="signup-btn">Sign up</button>
            </Link>
          </div>
        </div>
        <div className="hero-image">
          <img src="/crypto_mockup2.png" alt="Crypto app mockup" style={{ width: '70%' }} />
        </div>
      </section>
    </>
  );
}

export default Home;
